import React from 'react';
import css from './RippleSpinner.module.css';

function RippleSpinner() {
  return <div className={css.sbl}></div>;
}

export default RippleSpinner;
